import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { App } from './App'
import { store } from '~/store/store'
import { mutualTheme } from './utils/theme'
import './assets/fonts/Airbnb/FontFace.css'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider, StyledEngineProvider } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'
import { initializeTrackers } from './service/analytics'
import numeral from 'numeral'
import * as Sentry from '@sentry/react'

numeral.locale('pt-br')
initializeTrackers()

Sentry.init({
  dsn: process.env.PJ_PANEL_SENTRY_DSN,
  environment: process.env.PJ_PANEL_ENVIRONMENT || 'local',
  beforeSend: (event) => {
    if (process.env.NODE_ENV === 'development') {
      return null
    }
    return event
  }
})

ReactDOM.render(
  <Provider store={store}>
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={mutualTheme}>
        <CssBaseline />
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </StyledEngineProvider>
  </Provider>,
  document.getElementById('root')
)
